<script>
	import { popupModalOpen } from '$lib/popups/popupsStore';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import ProcessingIcon from '$lib/util/ProcessingIcon.svelte';
	import { getShortAddress, makeBodyScrollable } from '$lib/util/util';
	import { addingSmartContractWalletAuthorities } from '$lib/wallet/store';
	import { addSmartContractWalletAuthority } from '../scWallet';
	import { authorityAddressToAdd, smartContractWalletAddress } from '../store';
	function closeNotificationModal() {
		$popupModalOpen = false;
		makeBodyScrollable();
	}
</script>

<GradientBorder
	gradient="bg-fx-gradient-6 "
	paddingClass="p-px"
	borderRadius="rounded-2xl squircle"
	innerClassList="bg-fx-gradient-8 "
>
	<div class="flex flex-col justify-center items-center p-8 max-w-[350px]">
		<div class="text-fx-gradient-5 text-xl font-semibold">Add New Authority</div>
		<div class="border-t border-t-fx-grey-500 w-full my-2" />
		<ul class="text-fx-grey-300 text-xs list-disc my-4">
			<li>
				You are adding {$authorityAddressToAdd ? getShortAddress($authorityAddressToAdd) : ''} as a new
				authority to Smart contract wallet {$smartContractWalletAddress
					? getShortAddress($smartContractWalletAddress)
					: ''}.
			</li>
			<li class="mt-2">
				The new authority will have complete access over your Smart Contract wallet. They will be
				able to perform all the operations including but not limited to deposit, withdraw, add
				margin, withdraw margin, open trade, close trade, open limit/TP/SL orders, cancel
				limit/TP/SL orders etc.
			</li>
			<li class="mt-2">
				All authorities have equal access. Hence, the new authority will be able to remove any
				existing authorities including the creator.
			</li>
		</ul>
		<div class="grid grid-cols-2 w-full gap-4">
			{#if $addingSmartContractWalletAuthorities}
				<button
					class="bg-fx-grey-600 text-fx-grey-300 text-sm w-full h-10 font-semibold rounded-lg squircle-lg flex cursor-not-allowed gap-2 items-center justify-center"
				>
					<ProcessingIcon />
					<div>Adding</div>
				</button>
			{:else}
				<button
					on:click={() => {
						if ($authorityAddressToAdd) addSmartContractWalletAuthority($authorityAddressToAdd);
					}}
					class="bg-fx-blue text-fx-grey-100 text-sm w-full h-10 font-semibold rounded-lg squircle-lg"
					>Confirm</button
				>
			{/if}
			{#if $addingSmartContractWalletAuthorities}
				<button
					class="bg-fx-grey-600 text-fx-grey-300 text-sm w-full h-10 font-semibold rounded-lg squircle-lg cursor-not-allowed"
				>
					<div>Cancel</div>
				</button>
			{:else}
				<button
					class="bg-fx-grey-600 text-fx-grey-300 text-sm w-full h-10 font-medium rounded-lg squircle-lg"
					on:click={closeNotificationModal}>Cancel</button
				>
			{/if}
		</div>
	</div>
</GradientBorder>
